import { isSameDay, subDays, subHours, subWeeks } from 'date-fns';

const staticRangeHandler = {
  range: {},
  isSelected(range) {
    const definedRange = this.range();
    return (
      (isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)) ||
      definedRange.id === range.id
    );
  },
};

function createStaticRanges(ranges) {
  return ranges.map((range) => ({ ...staticRangeHandler, ...range }));
}

const TODAY = new Date();

const staticRanges = [
  {
    label: 'Last 24 hours',
    range: () => ({
      id: 1,
      startDate: subHours(TODAY, 24),
      endDate: TODAY,
    }),
  },
  {
    label: 'Last 7 days',
    range: () => ({
      id: 2,
      startDate: subDays(TODAY, 7),
      endDate: TODAY,
    }),
  },

  {
    label: '4 weeks',
    range: () => ({
      id: 3,
      startDate: subWeeks(TODAY, 4),
      endDate: TODAY,
    }),
  },
  {
    label: 'Custom',
    range: () => ({
      id: 4,
      startDate: TODAY,
      endDate: TODAY,
    }),
  },
];

export const initialRange = {
  startDate: subHours(TODAY, 24),
  endDate: TODAY,
  key: 'selection',
  id: 1,
};
export const last90Days = {
  startDate: subDays(TODAY, 90),
  endDate: TODAY,
  key: 'selection',
  id: 1,
};
export const last180Days = {
  startDate: subDays(TODAY, 180),
  endDate: TODAY,
  key: 'selection',
  id: 1,
};

export const RANGES = createStaticRanges(staticRanges);
